export interface ErrorsMessages {
  required: string;
  minLength: string;
  maxLength: string;
  uniqueness: string;
  notUnique: string;
  minMaxRangeError: string;
  categoryHasNoOptions: string;
  minDate: string;
  maxDate: string;
  invalid: string;
  startOutScope: string;
  endOutScope: string;
  min: string;
  max: string;
  minTime: string;
  maxTime: string;
  minMonth: string;
  maxMonth: string;
  invalidRange: string;
  pattern: string;
  urlInvalid: string;
  valueIsAlreadyExist: string;
  noTimeLinesExist: string;
  notAllFieldsSelected: string;
  validatePhoneNumber: string;
}
